import AnimatedSection from '../../../components/base/AnimatedSection';

export default function CTASection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center">
      <img 
        src="https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/56450e055b7efb9bbd024105f3ce09b9.png"
        alt="Studio"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Artist image — bottom center-right */}
      <div className="absolute bottom-0 right-[12%] w-[720px] h-[90vh] hidden md:block z-10">
        <img
          src="https://storage.readdy-site.link/project_files/48e4b772-a98b-4039-9a18-12ef0a8aa6d4/c70e8ed1-d98e-4086-aa64-ca432aa790c2_ChatGPT-Image-Mar-21-2026-12_45_55-PM.png?v=8ea98eea1ca3c5b4eb07dddab886175d"
          alt="Artist"
          className="w-full h-full object-contain object-bottom"
        />
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 w-full">
        <div className="flex flex-col justify-between min-h-[80vh]">
          <div className="pt-14 md:pt-20">
            <AnimatedSection animation="fade-up" delay={150}>
              <h2 className="text-4xl md:text-7xl font-bold text-white leading-tight max-w-3xl" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>
                ready to elevate<br />your sound?
              </h2>
            </AnimatedSection>
          </div>

          <div className="flex items-end justify-between pb-12 md:pb-20">
            <AnimatedSection animation="slide-right" delay={300}>
              <div className="text-white text-base md:text-xl font-light max-w-xs md:max-w-md" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>
                Browse hundreds of exclusive beats<br />
                Book your session today
              </div>
            </AnimatedSection>
          </div>
        </div>
      </div>
    </section>
  );
}
